"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_dom_1 = require("react-router-dom");
var useIsSmallScreen_1 = __importDefault(require("./useIsSmallScreen"));
var useIsMobileFullScreen = function () {
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var regex = new RegExp('(show|saved-vacancies|chats|recruiters|invites|applications/(active|concept|completed))/[0-9]');
    var isPath = pathname.match(regex);
    return !!isPath && isSmallScreen;
};
exports.default = useIsMobileFullScreen;
